import React from "react";
import Navlinks from "./Navlinks";
import "./Sidebar.css";
import Logo from "../../assets/images/StyLogo.png";

const Sidebar = ({ showSideBar, toggleSidebar }) => {
  return (
    <aside>
      <div
        className={
          showSideBar ? "sidebar-container" : "sidebar-container show-sidebar"
        }
      >
        <div className="content">
          <header>
            <img
              src={Logo}
              alt="Logo"
              style={{ height: "55px", width: "200px" }}
            />
          </header>
          <Navlinks />
        </div>
      </div>
    </aside>
  );
};
export default Sidebar;
